<template>
  <div class="hello">
    <img style="" :src="image" alt="">
    <input @change="previewImage" type="file" accept="image/*">
<br>
      <img v-bind:src="'data:image/jpeg;base64,'+output_image" alt=""/>
      <br>
      <button @click="uploadImage">Upload selected image</button>
      <br>
      <div class="image-preview" v-if="input_ImageData.length > 0">
        <img class="preview" :src="input_ImageData">
    </div>
    
    <div class="image-preview" v-if="output.length > 0">
      <img class="preview" :src="output">
  </div>
  </div>
</template>


<script>
import axios from 'axios';

axios.defaults.headers.common["x-api-key"] = "XhOg8uLQpG6xTjvMnG8CA4lbJBsYN2Fy5d3FHx8O"




export default {
  name: 'HelloWorld',
  data () {
    return {
      output_image: '',
      input_ImageData: "",
      output:"",
      fileName:"",
      image:""
    }
  },
  methods: {
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      this.fileName = input.files[0].name
      console.log(this.fileName)
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          var reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
              // Note: arrow function used here, so that "this.input_ImageData" refers to the input_ImageData of Vue component
              // Read image as base64 and set to input_ImageData
              this.input_ImageData = e.target.result;
          }
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);
          }
    },
    uploadImage() {
      const { image } = this.input_ImageData;
      console.log("Uploading image")
      axios.post('https://zjgk7i3rlf.execute-api.eu-west-1.amazonaws.com/dev/predict', { "image": this.input_ImageData, "image_name": this.fileName})
        .then((res) => {
        console.log(res.data.body['image_base64'])
        var bytestring = res.data.body['image_base64']
        this.output_image = bytestring.split('\'')[1]
        console.log(this.output_image)
        })}
    }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue